
import { Apis } from '@/appSettings'
import { useMutation, useQuery } from '@tanstack/react-query'
import axios from 'axios'
import type { LoggedUser } from 'BrokerTsLib/src/dtos/User/User'
import { longStaleTime } from 'BrokerTsLib/src/hooks'
import { useUrl } from '.'

export const useTranslationsGetUiBundle = (user: LoggedUser | null) => {
  const url = useUrl(Apis.translations)

  return useQuery({
    queryKey: ['translations', user?.languageId],
    queryFn: async () => {
      const response = await axios.get<Record<string, string>>(`${url}/GetUiBundle`)

      return response.data
    },
    staleTime: longStaleTime,
  })
}

export const useReloadTranslations = () => {
  const url = useUrl(Apis.translations)

  return useMutation({
    mutationFn: () =>
      axios.post(`${url}/ReloadTranslations`),
  })
}